import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import { Field, reduxForm } from 'redux-form';
import {validate, isProperFormat, isInRange} from '../../scripts/DateRangeValidation.js';

//import components
import DateRangeField from './DateRangeField.js';
import DateRangeFieldCheckbox from './DateRangeFieldCheckbox.js';

const DateRange = ({ handleSubmit, isSelected, submitting, min, max, pristine, reset, clang, mask, error, submitFailed, dirty, valid, invalid, setOpenedFilter}) => {
    return (
        <div className="date-range">
            <form onSubmit={handleSubmit}>
                <div className="date-range__date-fields">
                    <Field
                        name="from"
                        type="text"
                        component={DateRangeField}
                        mask={mask}
                        label={lang[clang].results.date_from}
                        placeholder={lang[clang].results.date_placeholder}
                        validate={[isProperFormat, isInRange]}/>
                    {(!min || min.toString().indexOf('-') >= 0) &&
                        <Field
                            name="fromBc"
                            component={DateRangeFieldCheckbox}
                            label={lang[clang].results.bc}/>}
                    <div className="date-range__separator">-</div>
                    <Field
                        name="to"
                        type="password"
                        mask={mask}
                        component={DateRangeField}
                        label={lang[clang].results.date_to}
                        placeholder={lang[clang].results.date_placeholder}
                        validate={[isProperFormat, isInRange]}/>
                    {(!max || max.toString().indexOf('-') >= 0) &&
                        <Field
                            name="toBc"
                            component={DateRangeFieldCheckbox}
                            label={lang[clang].results.bc}/>}
                </div>

                <div className="filter__submit-container">
                    {((error && submitFailed) || (dirty && invalid)) &&
                        <span className="date-range__form-error">{lang[clang].date_range[error]}</span>}
                    {valid && (dirty || !isSelected) &&
                        <button
                            type="submit"
                            disabled={submitting}
                            className="filter__submit active">
                            {lang[clang].results.submit}
                        </button>}
                    {((invalid) || (pristine && isSelected) ) &&
                        <button
                            type="button"
                            onClick={() => setOpenedFilter(null)}
                            className={`filter__submit`}>
                            {lang[clang].results.close}
                        </button>}
                </div>
            </form>
        </div>
    );
};

DateRange.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    validate
})(DateRange));



// WEBPACK FOOTER //
// ./src/components/date-range/DateRange.js